const formatLabel = require('./format_label')

const leftOffsetFactor = 0.8
const leftOffsetPixels = 5
const decimalPoints = 1

/**
 * Draws the "value" on a bar chart; is used as a Chart.js plugin.
 * According to the isNarrow parameter, it will either render
 * value to the right from the corresponding bar (isNarrow = false),
 * or print the value and category name above it (isNarrow = true).
 *
 * Uses common helper formatLabel to print the value in the format
 * that comes from the invocation config.
 *
 * @param {Number} options.fontSize [description]
 * @param {String} options.fontFamily [description]
 * @param {String} options.fontWeight [description]
 * @param {String} options.color [description]
 * @param {Boolean} options.isNarrow [description]
 * @param {String} options.unitLabel [description]
 */
const getDrawValue = ({ fontSize, fontFamily, fontWeight, color, isNarrow, unitLabel }) => chart => {
  const ctx = chart.ctx

  ctx.font = `normal ${fontWeight} ${fontSize}px ${fontFamily}`
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = color

  const getPosition = position => ([
    isNarrow
      ? fontSize * leftOffsetFactor
      : position.x + leftOffsetPixels,
    isNarrow
      ? position.y - fontSize
      : position.y
  ])

  const dataset = chart.data.datasets[0]
  const meta = chart.getDatasetMeta(0)

  if (!meta.hidden) {
    meta.data.forEach((element, index) => {
      const value = formatLabel(dataset.data[index].toFixed(decimalPoints), unitLabel)
      const text = isNarrow ? `${chart.data.labels[index]} (${value})` : value
      ctx.fillText(text, ...getPosition(element.tooltipPosition()))
    })
  }
}

module.exports = getDrawValue



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/helpers/draw_value.js